import { gql, useQuery, useMutation } from "@apollo/client";
import { Card, message, Spin, Switch, Typography } from "antd";
import { useTranslation } from "react-i18next";
import RobinPage from "../components/RobinPage";

const GET_MAINTENANCE_STATUS = gql`
  query GetMaintenanceStatus {
    maintenanceStatus {
      isUnderMaintenance
    }
  }
`;

const ENABLE_MAINTENANCE_MODE = gql`
  mutation EnableMaintenanceMode {
    setMaintenanceMode(input: { enabled: true }) {
      isUnderMaintenance
    }
  }
`;

const DISABLE_MAINTENANCE_MODE = gql`
  mutation DisableMaintenanceMode {
    setMaintenanceMode(input: { enabled: false }) {
      isUnderMaintenance
    }
  }
`;

function Maintenance() {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const { data, loading, refetch } = useQuery<{
    maintenanceStatus: { isUnderMaintenance: boolean };
  }>(GET_MAINTENANCE_STATUS);

  const [enableMaintenance, { loading: enabling }] = useMutation<{
    setMaintenanceMode: { isUnderMaintenance: boolean };
  }>(ENABLE_MAINTENANCE_MODE, {
    onCompleted: () => {
      messageApi.success(t("label.maintenance.enabled"));
      refetch();
    },
    onError: (error) => {
      messageApi.error(t("message.error.generic") || error.message);
    },
  });

  const [disableMaintenance, { loading: disabling }] = useMutation<{
    setMaintenanceMode: { isUnderMaintenance: boolean };
  }>(DISABLE_MAINTENANCE_MODE, {
    onCompleted: () => {
      messageApi.success(t("label.maintenance.disabled"));
      refetch();
    },
    onError: (error) => {
      messageApi.error(t("message.error.generic") || error.message);
    },
  });

  const isUnderMaintenance = data?.maintenanceStatus?.isUnderMaintenance ?? false;
  const toggleLoading = enabling || disabling;

  const handleToggle = (checked: boolean) => {
    if (checked) {
      enableMaintenance();
    } else {
      disableMaintenance();
    }
  };

  return (
    <RobinPage title={t("label.menu.maintenance")}>
      {contextHolder}
      <Card>
        <Spin spinning={loading}>
          <Typography.Paragraph strong style={{ marginBottom: 16 }}>
            {t("label.maintenance.system_under_maintenance")}
          </Typography.Paragraph>
          <Switch
            checked={isUnderMaintenance}
            loading={toggleLoading}
            onChange={handleToggle}
            checkedChildren={t("label.yes")}
            unCheckedChildren={t("label.no")}
          />
        </Spin>
      </Card>
    </RobinPage>
  );
}

export default Maintenance;
